import React, { memo } from 'react';

import { MULTI_SITE_AOI_STEPS, MULTI_SITE_STEPS, isAOIOrder, isAppointmentJourney } from 'common/constants/app.constants';

import Stepper from 'featureLib/Stepper';

type StepperComponentProps = {
  activeStep: number;
};

export const AuthStepper = ({ activeStep }: StepperComponentProps) => {
  let authSteps = [MULTI_SITE_STEPS.SUBMIT_ORDER_DETAILS, MULTI_SITE_STEPS.FEASIBILITY_CHECK, MULTI_SITE_STEPS.PLAN_CONFIGURATION, MULTI_SITE_STEPS.CONFIRM_ORDER_DETAILS];

  if (isAOIOrder()) {
    authSteps = [MULTI_SITE_AOI_STEPS.ACCOUNT_DETAILS, MULTI_SITE_AOI_STEPS.FEASIBILITY, MULTI_SITE_AOI_STEPS.BILLING_AND_PRICING, MULTI_SITE_AOI_STEPS.KYC];
  }

  if (isAppointmentJourney()) {
    authSteps.push(MULTI_SITE_STEPS.CONFIRM_INSTALLATION);
  }

  return (
    <div className={`${isAOIOrder() ? 'aoi_header' : 'non_aoi_header'}`}>
      <Stepper steps={authSteps} activeStep={activeStep - 1}></Stepper>
    </div>
  );
};

export default memo(AuthStepper);
